import { render, staticRenderFns } from "./KpiRevenue.vue?vue&type=template&id=55691b54&scoped=true"
import script from "./KpiRevenue.vue?vue&type=script&lang=js"
export * from "./KpiRevenue.vue?vue&type=script&lang=js"
import style0 from "./KpiRevenue.vue?vue&type=style&index=0&id=55691b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55691b54",
  null
  
)

export default component.exports